import { render, staticRenderFns } from "./ArticleHeader.vue?vue&type=template&id=32de9c66&"
import script from "./ArticleHeader.vue?vue&type=script&lang=js&"
export * from "./ArticleHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports